import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
const release = document.head.querySelector('meta[name="release-hash"]').content;
// Indicates if we are leaving the current page
let pageUnloading = false;


/**
 * Wrapper for sentry captureException. Ignores request aborts that happen due to leaving the page
 *
 * @param {Array} args the variable number of arguments to pass to sentry
 * @returns {void}
 */
function captureException (...args) {
	if (pageUnloading && args[0] && args[0].message === 'Request aborted') {
		return;
	}
	if (typeof Sentry !== 'undefined') {
		Sentry.captureException(...args);
	} else {
		window.console.error(...args);
	}
}


/**
 * Initializes sentry with default settings
 *
 * @param {Vue} app
 */
function initializeSentry (app) {
	window.addEventListener('beforeunload', () => {
		pageUnloading = true;
	});
	Sentry.init({
		dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
		release,
		environment: process.env.NODE_ENV,
		integrations: [
			new Integrations.Vue({
				app,
				attachProps: true,
			}),
		],
		sendClientReports: false,
	});
	window.Sentry = Sentry;
	window.captureException = captureException;
}

export default initializeSentry;
